"use client";

import Image from "next/image";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

import { LanguageSwitcherButton } from "@/components/ui/language-switcher";
import { ThemeSwitcher } from "@/components/ui/theme-switcher";

export default function AuthLayoutClient({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useJsonTranslation("AuthLayout");

  return (
    <div className="xs:p-4 xs:pt-[calc(1rem+env(safe-area-inset-top))] xs:pb-[calc(1rem+env(safe-area-inset-bottom))] relative flex min-h-screen items-center justify-center overflow-hidden p-3 pt-[calc(0.75rem+env(safe-area-inset-top))] pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      {/* Ambient glow */}
      <div className="animate-aurora bg-leaf-500/8 pointer-events-none absolute top-1/4 left-1/4 h-96 w-96 rounded-full blur-3xl" />
      <div className="animate-aurora bg-leaf-500/6 pointer-events-none absolute right-1/4 bottom-1/4 h-96 w-96 rounded-full blur-3xl [animation-delay:4s]" />

      <div className="relative w-full max-w-md space-y-8">
        <div className="text-center">
          <h1 className="font-display flex items-center justify-center gap-3 text-2xl font-bold tracking-tight sm:text-3xl">
            <Image
              src="/logo-icon.png"
              alt="VidSeeds.ai"
              width={40}
              height={40}
              className="h-10 w-auto"
            />
            <span>
              <span className="text-foreground">Vid</span>Seeds
              <span className="text-primary">.ai</span>
            </span>
          </h1>
          <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
            {t("subtitle")}
          </p>
        </div>
        {children}
        <div className="flex items-center justify-center gap-2">
          <ThemeSwitcher />
          <LanguageSwitcherButton />
        </div>
      </div>
    </div>
  );
}
